import { supabase } from "@/lib/supabase";
import {
  processAndUploadImage,
  uploadProcessedImage,
} from "@/lib/image-processor";

const BUCKET = "covers";

export async function uploadFile(
  file: File,
  userId: string,
  onProgress?: (status: "processing" | "done" | "error", message?: string) => void
): Promise<string> {
  try {
    const result = await processAndUploadImage({
      file,
      bucket: BUCKET,
      folder: userId,
      kind: "product",
      prefix: "product",
      onProgress,
    });
    return result.path;
  } catch (error) {
    throw new Error(
      error instanceof Error
        ? error.message
        : "No pudimos procesar esta imagen. Usa una imagen JPG, PNG o WEBP."
    );
  }
}

/** Sube un blob (imagen ya procesada/compuesta, p. ej. con ticket) a productos. */
export async function uploadProductBlob(
  blob: Blob,
  userId: string,
  originalName: string
): Promise<string> {
  void originalName;
  const result = await uploadProcessedImage({
    blob,
    bucket: BUCKET,
    folder: userId,
    kind: "product",
    prefix: "product",
  });
  return result.path;
}